// extracted by mini-css-extract-plugin
export default {"menu":"GraphMenu_menu__oGaNQ","zoomSection":"GraphMenu_zoomSection__ukArh","sectionTitle":"GraphMenu_sectionTitle__KP9vr"};